
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'checkmark': {
    width: 10.7,
    height: 8.2,
    viewBox: '0 0 10.7 8.2',
    data: '<path pid="0" d="M3.5 8.2L0 5.1l1.3-1.5 2.2 1.9L9.4 0l1.3 1.5z"/>'
  }
})
